//import './env'
import './sentry'



// WEBPACK FOOTER //
// ./resources/js/config/index.js